
// import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import styles from "../../styles/modal/modal.module.scss";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import CustomInput from "../../components/CustomInput/CustomInput";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import useNotiStack from "../../hooks/useNotistack";
import validationText from "../../json/messages/validationText";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { UpdateMCMemberPassword } from "../../api/functions/MCMember.api";
import { adminMemberData, isPasswordMismatch } from "../../services/utils";


const schema = yup.object().shape(
  {
    password: yup
      .string()
      .trim()
      .required(<p style={{ fontSize: "12px" }}>{validationText.error.enter_password}</p>)
      .when("password", {
        is: (value) => value,
        then: (rule) => rule.min(4,"At least 4 characters").max(255).label("password"),
      })
      .when("confirmPassword", {
        is: (value) => value,
        then: (rule) => rule.min(4,"At least 4 characters").max(255).label("password"),
      }),
    confirmPassword: yup.string().when("password", {
      is: (value) => value,
      then: (rule) =>
        rule
          // .required(<p style={{ fontSize: "12px" }}>{validationText.error.confirm_password}</p>)
          .required(<p style={{ fontSize: "12px" }}>Confirm password is required</p>)
          // .oneOf([yup.ref("password"), null])
          .label("Confirm password"),
    }),
     
  },
  [
    ["password", "password"],
    ["confirmPassword", "password"],
  ]
);

export default function InputModal({
  // onSubmit,
  open,
  onClose,
  scroll,
  title,
  // value,
  // onChange,
  cancleBtnClick,
  // saveBtnClick,
}) {

  const params = useParams();
  const { toastSuccess } = useNotiStack();
  const user = adminMemberData();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const isNotMatchPassword = isPasswordMismatch(
    watch("password"),
    watch("confirmPassword")
  );

  const { mutateAsync: mutateAsyncUpdateMCMemberPassword, isLoading  } = useMutation({
    mutationFn:(payloadData)=> UpdateMCMemberPassword(payloadData,user),
    onSuccess: (response) => {
      if (response.Status === 1) {
        toastSuccess("Password updated successfully")
        onClose();
      }
    }
  });

  const onSubmit =(data)=>{
    const payload={
      id_member: params?.id,
      newPassword: data?.password?.trim()
    }
    mutateAsyncUpdateMCMemberPassword(payload)
    reset();
  }

  return (
    <Dialog
      // fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      scroll={scroll}
      className={styles.input_modal}
      aria-labelledby="responsive-dialog-title"
    >
      <Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          className={styles.modal_stck}
        >
          <Typography className={styles.modal_title}>{title}</Typography>
        </Stack>
      </Box>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box className={styles.form_wrap}>
            <Box className={styles.form_group}>
           
            <Controller
                              control={control}
                              name="password"
                              render={({ field: {value, onChange } }) => (
               <CustomInput value={value} autoFocus={true}
                placeholder="New Password"
                type="password"
                name="password"
                onChange={onChange}
                disabled={isLoading}
                error={Boolean(errors?.password)}
                 helperText={errors?.password?.message}
              />
                              )}
                              />
             
             
            </Box>
            <Box className={styles.form_group}>
            <Controller
                              control={control}
                              name="confirmPassword"
                              render={({ field: { value,onChange } }) => (
              <CustomInput value={value}
                placeholder="Confirm Password"
                type="password"
                name="password" 
                onChange={onChange}
                disabled={isLoading}
                error={Boolean(errors?.confirmPassword)}
                helperText={errors?.confirmPassword?.message}
              />
              )}
              />
                      {getValues("confirmPassword") && isNotMatchPassword && (
                      <p className={styles.error_text}>
                        {validationText.error.password_mismatch}
                      </p>
                    )}
            </Box>
          </Box>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className={styles.btn_stck}
          >
            <Button onClick={cancleBtnClick} className={styles.black_btn}>
              <Typography variant="body1">Cancel</Typography>
            </Button>
      
            <Button type="submit" className={styles.blue_btn} 
                    disabled={isNotMatchPassword} >
             <Typography variant="body1">{isLoading ? "Saving.." : "Save"}</Typography>
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
}
